import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const CloudDownloadSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2568 7.90014C21.0273 5.82256 20.0491 3.89964 18.5051 2.49069C16.9611 1.08174 14.957 0.283147 12.8671 0.244141C11.2705 0.261615 9.71154 0.73111 8.37081 1.59823C7.03008 2.46535 5.96248 3.6946 5.2917 5.14357C3.60214 5.65767 2.14933 6.75368 1.19107 8.23712C0.232798 9.72057 -0.168967 11.4955 0.0570617 13.247C0.28309 14.9986 1.1223 16.6134 2.42577 17.8049C3.72924 18.9965 5.41269 19.6878 7.17741 19.7561H17.6774C18.5226 19.7425 19.3568 19.5623 20.1323 19.2258C20.9077 18.8893 21.6092 18.4032 22.1964 17.7952C22.7837 17.1872 23.2453 16.4694 23.5547 15.6827C23.8642 14.8961 24.0154 14.0562 23.9997 13.211C23.9964 12.1717 23.7459 11.1481 23.269 10.2247C22.7921 9.30123 22.1024 8.50447 21.2568 7.90014ZM16.5837 11.7144L12.514 15.7893C12.3774 15.9254 12.1925 16.0018 11.9997 16.0018C11.8069 16.0018 11.622 15.9254 11.4854 15.7893L7.4157 11.7144C7.31357 11.6126 7.24395 11.4828 7.21565 11.3414C7.18735 11.2 7.20164 11.0534 7.2567 10.9202C7.31177 10.7869 7.40514 10.673 7.52499 10.5928C7.64485 10.5127 7.78579 10.4699 7.92998 10.4699H10.5426V7.01728C10.5426 6.63082 10.6961 6.26019 10.9693 5.98693C11.2426 5.71366 11.6132 5.56014 11.9997 5.56014C12.3862 5.56014 12.7568 5.71366 13.0301 5.98693C13.3033 6.26019 13.4568 6.63082 13.4568 7.01728V10.4733H16.0677C16.211 10.4744 16.3507 10.5177 16.4696 10.5977C16.5885 10.6777 16.6812 10.7909 16.7362 10.9232C16.7912 11.0555 16.8061 11.2011 16.7789 11.3417C16.7518 11.4824 16.6839 11.612 16.5837 11.7144Z"
        fill={fill}
      />
    </svg>
  </span>
);

export default CloudDownloadSVG;
